import React from "react";
import { makeStyles, CardMedia } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  media: {
    width: "160px",
    height: "90px",
    borderRadius: "8px",
    [theme.breakpoints.down("md")]: {
      width: "120px",
      height: "70px",
    },
  },
  box: {
    position: "absolute",
    borderRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const WeOffer = ({ image, title, top, right }) => {
  const classes = useStyles();
  return (
    <div className={classes.box} style={{ top: top, right: right }}>
      <CardMedia className={classes.media} image={image} title={title} />
    </div>
  );
};

export default WeOffer;
